<template>
  <div class="container-fluid center">
    <portlet
        style="min-width:400px;"
          :footer="true"
        :title="'Workfix Portal'"
        :actions-block="false"

    >
         <template slot="portletBody">
            <div class="row">
                <div class="form-group col-lg-12">
                    <label for="login-email">Email</label>
                    <input
                            name="login-email"
                            id="login-email"
                            type="email"
                            class="form-control"
                            v-model="Login.email"
                    />
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-12">
                    <label for="password-login">Password</label>
                  <i class="float-right fas "  @click="showPass  = !showPass " :class="showPass ? 'fa-eye'  :  'fa-eye-slash'"></i>
                    <input
                            name="password-login"
                            id="password-login"
                            :type="showPass ? 'text' : 'password'"
                            class="form-control"
                            v-model="Login.password"
                    />
                </div>
            </div>
            <forgot-password
                :title="'Password Recovery'"
                :name="'password-recovery'"
                @passwordRecovery="forgot($event)"
            >
            </forgot-password>
        </template>
        <div slot="portletFooter" class="col text-center">
            <button @click="login()" type="submit" class="btn btn-primary">
                <i class="fal fa-save mr-2"></i> Login
            </button>
          <br>
          <hr>
            <i title=" " class="button" style="cursor:'pointer'" data-target="#password-recovery" data-toggle="modal">I forgot my password</i>
        </div>
    </portlet>
  </div>
</template>

<script>
    import forgotPassword from '../../components/forgotPassword.vue'
    import firebase from 'firebase/app';
import Vue from 'vue'
    import {DEACTIVATED_ACCOUNT, markPortalLoginPending} from '@/utils/portalLogin';

    export default {
      name:'Login',
        data() {
            return {
                disableNavigation: false,
              showPass:false,
                Login: {
                    email: null, //'oscar.toledo@bluecodesolutions.com',
                    password: null, //'Development#123@',
                },
            };
        },
        methods: {
            login() {
              this.$store.commit('setLoading',true)
                firebase.auth().signInWithEmailAndPassword(this.Login.email, this.Login.password)
                .then((userCredential) => {
                    // Signed in

                    userCredential.user.getIdToken(/* forceRefresh */ true).then(function(idToken) {
                        Vue.prototype.$USER = userCredential.user
                        window.localStorage.setItem('firebaseToken', idToken);
                        markPortalLoginPending();
                        window.location = window.location.origin;
                    }).catch(function(error) {
                        // Handle other errors such as wrong password.
                    });
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    console.log(errorCode)
                  if(errorCode === 'auth/wrong-password'){
                    this.$swal({title:"Oops" ,text: 'Wrong credentials'})
                  }
                  if(errorCode == 'auth/too-many-requests')
                    this.$swal({title:"Oops" ,text: errorMessage})
                  if(errorCode === 'auth/user-disabled')
                    this.$swal({title:"Oops" ,text: DEACTIVATED_ACCOUNT})

                  this.$store.commit('setLoading',false)
                });
            },
            forgot(email) {
                firebase.auth().sendPasswordResetEmail(email).then(result => {
                    console.log(result)
                })
            },
        },
        components: {
            forgotPassword
        },
      created(){

      }
    };
</script>


<style>
.center{
  display: flex;
  justify-content: center;
  align-items: center;
  //text-align: center;
  min-height: 100vh;

}
</style>